import { createContext, useContext, type ReactNode } from "react";
import type { EnvKey } from "@/lib/env";
import { AuthGate } from "./AuthGate";
import { SetupScreen } from "./SetupScreen";

/** Result of bootstrapping MSAL in main.tsx. */
export type AuthStatus = { state: "ready" } | { state: "unconfigured"; missing: EnvKey[]; error?: string };

const AuthStatusContext = createContext<AuthStatus>({ state: "unconfigured", missing: [] });

export const AuthStatusProvider = AuthStatusContext.Provider;

export function useAuthStatus(): AuthStatus {
  return useContext(AuthStatusContext);
}

/** Route-level guard: setup screen when Entra isn't configured, otherwise sign-in. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const status = useAuthStatus();
  if (status.state !== "ready") return <SetupScreen missing={status.missing} error={status.error} />;
  return <AuthGate>{children}</AuthGate>;
}
